import { render, staticRenderFns } from "./AdvisoryStatusTable.vue?vue&type=template&id=89b0e1cc"
import script from "./AdvisoryStatusTable.vue?vue&type=script&lang=js"
export * from "./AdvisoryStatusTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports